import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { GlobalMessageService, GlobalMessageType, RoutingService, TranslatePipe } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, throwError } from 'rxjs';
import { take } from 'rxjs/operators';
import { ChangePayload, PasswordService } from 'src/app/service/user/password.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSuffix,
    MatIcon,
    MatError,
    AsyncPipe,
    UpperCasePipe,
    TranslatePipe,
  ],
})
export class ChangePasswordComponent implements OnInit {
  data$: Observable<any[]> = this.componentData.data$;
  changePasswordForm: FormGroup;
  payload: ChangePayload = { oldPassword: '', newPassword: '' };
  errorMsg = '';
  hideOldPassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;
  cancelled = false;
  buttonNoUpdate = true;
  constructor(
    protected componentData: CmsComponentData<any>,
    private formBuilder: FormBuilder,
    private passwordService: PasswordService,
    private router: Router,
    private globalMessageService: GlobalMessageService,
    private routingService: RoutingService
  ) {}

  ngOnInit() {
    this.data$.pipe(take(1)).subscribe((data) => data);
    this.changePasswordForm = this.formBuilder.group(
      {
        oldPassword: ['', [Validators.required]],
        newPassword: [
          '',
          [
            Validators.required,
            Validators.pattern(
              '^(?=.*?[A-Z])(?=.*?[a-z])?(?=.*?[0-9])(?=.*?[_:#?!@$%^&*{}<>\\\\\\/()+=;\'"\\[\\]|,.~`-]).{8,}$'
            ),
          ],
        ],
        confirmPassword: ['', [Validators.required]],
      },
      { validator: this.mustMatch('newPassword', 'confirmPassword') }
    );
  }

  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  changePassword() {
    if (this.cancelled) {
      return;
    }
    const newPassword = this.changePasswordForm.controls.newPassword.value;
    const oldPassword = this.changePasswordForm.controls.oldPassword.value;

    if (this.changePasswordForm.invalid) {
      return;
    } else {
      this.payload.newPassword = newPassword;
      this.payload.oldPassword = oldPassword;
      this.passwordService
        .changeUserPassword(this.payload)
        .pipe(take(1))
        .subscribe(
          (data) => {
            this.router.navigateByUrl('/my-account');
            this.globalMessageService.add(
              { key: 'changePasswordForm.success' },
              GlobalMessageType.MSG_TYPE_CONFIRMATION
            );
          },
          (err) => {
            this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
            this.globalMessageService.add(err.error.errors[0].message, GlobalMessageType.MSG_TYPE_ERROR);
          }
        );
    }
  }

  triggerCancel() {
    this.cancelled = true;
    this.routingService.goByUrl('/my-account');
  }

  disablingButton(passwordFormGroup: FormGroup): boolean {
    passwordFormGroup.valueChanges.subscribe((data: any) => {
      if (this.checkFormValues(data)) {
        this.buttonNoUpdate = false;
      } else {
        this.buttonNoUpdate = true;
      }
    });
    return this.buttonNoUpdate;
  }

  checkFormValues(data: any): boolean {
    return data.oldPassword !== '' || data.newPassword !== '' || data.confirmPassword !== '';
  }

  errorHandlr(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
